import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable, map, tap, filter } from 'rxjs';
import { IAssemblyLoaderService } from '@infinitform/platform-core';

@Injectable()
export class AssemblyLoaderCloudService implements IAssemblyLoaderService {
  private readonly http = inject(HttpClient);

  loadAssembly(
    source: string,
    onProgress?: (percent: number) => void
  ): Observable<ArrayBuffer> {
    return this.downloadBinary(source, onProgress);
  }

  loadOptimizedResult(
    source: string,
    onProgress?: (percent: number) => void
  ): Observable<ArrayBuffer> {
    return this.downloadBinary(source, onProgress);
  }

  loadTextData(source: string): Observable<string> {
    return this.http.get(source, { responseType: 'text' });
  }

  private downloadBinary(
    url: string,
    onProgress?: (percent: number) => void
  ): Observable<ArrayBuffer> {
    if (!onProgress) {
      return this.http.get(url, { responseType: 'arraybuffer' });
    }

    return this.http
      .get(url, {
        responseType: 'arraybuffer',
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        tap((event) => {
          if (
            event.type === HttpEventType.DownloadProgress &&
            event.total
          ) {
            onProgress(Math.round((event.loaded / event.total) * 100));
          }
        }),
        filter((event) => event.type === HttpEventType.Response),
        map((event) => {
          if (event.type === HttpEventType.Response) {
            return event.body as ArrayBuffer;
          }
          throw new Error('Unexpected event type');
        })
      );
  }
}
